import { PushService } from 'rev-shared/push/PushService';
import { SignalRHubsConnection } from 'rev-shared/push/SignalRHubsConnection';

import { SecurityContextService } from './SecurityContext.Service';
import { UserContextService } from './UserContext.Service';

export function securityBootstrap(
	pushService: PushService,
	SecurityContext: SecurityContextService,
	signalRHubsConnection: SignalRHubsConnection,
	UserContext: UserContextService
): Promise<void> {
	let csrfToken = UserContext.getCsrfToken();
	let isLoggedIn = UserContext.isUserLoggedIn();

	UserContext.userAuthenticated$.subscribe(updateSecurityToken);
	UserContext.userIdChangedForSecurityReload$.subscribe(() => {
		//session is stable. no need for any $timeout...
		if (UserContext.isSessionStable()) {
			reloadAuthorization();
			return;
		}
		//allow time for userId unsubscribe to complete
		window.setTimeout(() => reloadAuthorization(), 500);
	});

	signalRHubsConnection.reconnected$.subscribe(() => updateSecurityToken());

	return reloadAuthorization();

	function reloadAuthorization(): Promise<void> {
		updateSecurityToken();
		return SecurityContext.reloadAuthorization();
	}

	function updateSecurityToken(): void {
		const newIsLoggedIn = UserContext.isUserLoggedIn();
		const accessToken = UserContext.getUser().token?.accessToken;
		const newCsrfToken = UserContext.getCsrfToken();

		if (csrfToken !== newCsrfToken || isLoggedIn !== newIsLoggedIn) {
			csrfToken = newCsrfToken;
			isLoggedIn = newIsLoggedIn;
			signalRHubsConnection.bounce()
				.then(() => pushService.setToken(accessToken, newCsrfToken))
				.catch(e => console.error('updateSecurityToken: ', e));
		}
		else {
			pushService.setToken(accessToken, newCsrfToken);
		}
	}
}

